import { useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';

export const useColliDetailModal = () => {
    const { currentAccount } = useAccountRepository();
    const { openModal, closeModal } = useModals();

    return {
        currentAccount,
        openModal,
        closeModal
    };
};
